/*******************************************************
 * LEAFLET SERVICE
 *
 * En charge
 * - d'afficher une carte leaflet
 * - gérer affichage de markers
 *******************************************************/


angular.module("services")
	.factory("LeafletService", ["leafletData", function (leafletData) {

		"use strict";

		var mapId;

		var api = {

			// data storage. Can be accessed accross angular objects
			markers: [],
			center: {},
			customControls: {}, // Initialisé plus tard.

			// API Functions / variables
			createMarker: createMarker,
			reset: reset,
			createMarkerWithName: createMarkerWithName,
			markerFaCustomization: markerFaCustomization,
			deleteAllMarkers: deleteAllMarkers,
			getMapId: getMapId,
			setCenter: setCenter,
			setZoom: setZoom,
			setMapId: function (newMapId) {
				mapId = newMapId;
			}
		};


		/**
		 * Réinitialiser
		 */
		function reset() {
			api.markers = [];
			api.center = {};
			api.customControls = {};
		}

		/**
		 * Définir le centre de la carte
		 */
		function setCenter(newCenter) {
			api.center = newCenter;
		}

		/**
		 * Change le niveau de zoom sans changer le center
		 * @param zoom
		 */
		function setZoom(zoom) {
			api.center = {
				lat: api.center.lat,
				lng: api.center.lng,
				zoom: zoom
			};
		}

		/**
		 * Récupérer l'id de la map
		 */
		function getMapId() {
			return mapId;
		}

		/**
		 * Supprimer tous les markers
		 */
		function deleteAllMarkers() {
			api.markers = [];
		}

		/**
		 * Ajouter un marker
		 * @param marker
		 */
		function createMarker(marker) {
			api.markers.push(marker);
		}

		/**
		 * Ajouter un marker possédant un nom
		 * @param name, marker
		 */
		function createMarkerWithName(name, marker) {
			api.markers[name] = marker;
		}

		/**
		 * Personnaliser un marker
		 * icon : 'flag', 'university'
		 * color : 'white', 'blue', 'green'
		 * @param marker
		 * @param icon
		 * @param color
		 * @returns {*}
		 */
		function markerFaCustomization(marker, icon, color) {
			marker.icon = {
				type: "awesomeMarker",
				icon: icon,
				prefix: "fa",
				markerColor: color
			};
			return marker;
		}

		return api;

	}]
	);


